import helper from '../../../helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('portaliServiziTop');
export const actions = helper.createActions('portaliServiziTop', actionTypes);